import React from "react";

export function SubmissionFeedback({ submission }) {
  if (!submission.message) return null;
  return (
    <div role="alert" className="alert alert-warning">
      <p className="text-dark mb-2">{submission.message}</p>
      {submission.canCheckStatus && (
        <button type="button" className="btn btn-secondary tw-mb-2" style={{ marginRight: 12 }} disabled={submission.checkingStatus}
          onClick={submission.checkStatus}>
          {submission.checkingStatus ? "Checking submission…" : "Check submission status"}
        </button>
      )}
      {submission.unresolved && <a className="text-dark" style={{ textDecoration: "underline" }}
        href="/properties" target="_blank" rel="noopener noreferrer">Check Properties</a>}
    </div>
  );
}
